var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserVerified = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--sscs-interactive)",
  d: "m12 2.5 7.5 2.7v5.4c0 4.7-3.1 8.7-7.5 10.9-4.4-2.2-7.5-6.2-7.5-10.9V5.2Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9.1,
  r: 2.4,
  stroke: "var(--sscs-text-inverse)",
  strokeWidth: 1.7
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--sscs-text-inverse)",
  strokeLinecap: "round",
  strokeWidth: 1.7,
  d: "M7.9 16.2c.8-2.2 2.3-3.1 4.1-3.1 1.8 0 3.3.9 4.1 3.1"
})));
export default SvgUserVerified;